module.exports = __webpack_public_path__ + "index/img/SmartFireZh.f8aa935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SmartFireZh.png
// module id = 5FoY
// module chunks = 2